module.exports = __webpack_public_path__ + "img/tor.0353433a.png";